import { Injectable } from '@angular/core';
import { BpCorporate } from '../model/bp-corporate';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';

@Injectable({
    providedIn: 'root'
  })
  export class BpCorporateService{
  
    constructor(private _restClientService : RestClientService) { }

    getBpCorporateBycodeclient(codeclient){
        
        return this._restClientService.load<BpCorporate>('bp-corporate/bp-corporate-by-codeclient/'+codeclient);
    }
  
}      

    